import { css } from "@emotion/css";
import styled from "@emotion/styled";
import { BorderRadius, Colors, FontSizeInPx, Fonts, Spacing } from "@snapchat/snap-design-system";

export const BANNER_HEIGHT = 160;

export const BannerWrapper = styled.div`
    position: relative;
    overflow: hidden;
    height: ${BANNER_HEIGHT}px;
    border-radius: ${BorderRadius.container}px;
`;

export const bannerFit = css`
    position: absolute;
    z-index: 0;
    top: 0;
    left: 0;

    display: block;

    width: 100%;
    height: 100%;

    object-fit: cover;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const Overlay = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    height: 100%;
    padding: ${Spacing.MD}px;
`;

export const Title = styled.h1<{ isInverted?: boolean }>`
    ${Fonts.Heading.H300};
    position: relative;
    z-index: 1;

    margin-bottom: ${Spacing["2XS"]}px;

    color: ${({ isInverted }) => (isInverted ? Colors.Black.V200 : Colors.WHITE)};
    text-align: center;
`;

export const Subtitle = styled.p<{ isInverted?: boolean }>`
    position: relative;
    z-index: 1;

    margin: 0;

    font-size: ${FontSizeInPx.COMPACT}px;
    color: ${({ isInverted }) => (isInverted ? Colors.Black.V200 : Colors.WHITE)};
    text-align: center;
`;

export const bannerLink = css`
    position: relative;
    z-index: 1;
    margin-top: ${Spacing.MD}px;
`;
